import {Grid, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import FocusThankYou from 'components/payment/FocusThankYou';

const useStyles = makeStyles(theme => ({
    heading: {
        marginBottom: '.5em',
        color: '#0B5D98',
    },
    subheading: {
        margin: '0 0 .5em 0',
    },
    summary: {
        padding: '0px',
    },
}));

const SeaServiceMMCPaymentThankYouPage = () => {
    const classes = useStyles();

    return (
        <Grid container>
            <Grid
                item
                xs={12}
                style={{
                    margin: '1.5em auto',
                    maxWidth: 'fit-content',
                    borderBottom: '4px solid #0B5D98',
                }}
            >
                <Typography
                    className={classes.heading}
                    fontWeight='fontWeightBold'
                    variant='h6'
                    align='center'
                >
                    THANK YOU
                </Typography>
            </Grid>
            <Grid item xs={12} style={{marginBottom: '1.5em'}}>
                <FocusThankYou />
            </Grid>
            <Grid
                container
                style={{
                    padding: '1em',
                    display: 'block',

                    maxWidth: '40em',
                    margin: 'auto',
                }}
            ></Grid>
        </Grid>
    );
};

export default SeaServiceMMCPaymentThankYouPage;
